// Estado de repouso: um botão grande para começar a gravar. Não há mockup aprovado
// para esta tela (os mockups cobrem "gravando" e "código pronto") — desenhada na mesma
// linguagem escura. Traz também o fallback "enviar um arquivo de áudio" (o requisito
// pede "grava OU envia arquivo"): serve quando o microfone está bloqueado pela TI do
// aparelho ou o médico já tem uma gravação.

import { useRef } from 'react';

import { corC, fonteC } from '../../styles/tokensCelular';

interface Props {
  onGravar: () => void;
  onArquivo: (f: File) => void;
  erro: string | null;
}

export function Repouso({ onGravar, onArquivo, erro }: Props): JSX.Element {
  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '14px 20px 20px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          fontFamily: fonteC.mono,
          fontSize: 11,
          color: corC.muted,
          letterSpacing: '.08em',
        }}
      >
        <span style={{ fontFamily: fonteC.condensada, fontSize: 20, fontWeight: 600, letterSpacing: 0 }}>
          v<span style={{ color: corC.ondaRecente }}>med</span>
        </span>
        <span>SEM LOGIN</span>
      </div>

      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 22,
        }}
      >
        <button
          type="button"
          onClick={onGravar}
          aria-label="Gravar consulta"
          style={{
            width: 168,
            height: 168,
            borderRadius: '50%',
            border: `1px solid ${corC.borda}`,
            background: 'transparent',
            color: corC.texto,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 14,
            cursor: 'pointer',
          }}
        >
          <span
            style={{ width: 34, height: 34, borderRadius: '50%', background: corC.vermelho, display: 'block' }}
          />
          <span
            style={{
              fontFamily: fonteC.condensada,
              fontWeight: 600,
              fontSize: 20,
              letterSpacing: '.14em',
            }}
          >
            GRAVAR
          </span>
        </button>
        <div style={{ fontSize: 13, color: corC.muted, textAlign: 'center', maxWidth: 260, lineHeight: 1.5 }}>
          Grave a consulta pelo celular. O áudio é apagado logo após a transcrição.
        </div>
      </div>

      {erro && (
        <div
          style={{
            fontSize: 13,
            lineHeight: 1.5,
            color: corC.avisoTexto,
            background: corC.avisoBg,
            border: `1px solid ${corC.avisoBorda}`,
            padding: '10px 12px',
            marginBottom: 12,
          }}
        >
          {erro}
        </div>
      )}

      <div style={{ borderTop: `1px solid ${corC.divisorFraco}`, paddingTop: 14, textAlign: 'center' }}>
        <input
          ref={inputRef}
          type="file"
          accept="audio/*"
          style={{ display: 'none' }}
          onChange={(e) => {
            const f = e.target.files?.[0];
            if (f) onArquivo(f);
            e.target.value = ''; // permite reenviar o mesmo arquivo
          }}
        />
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          style={{
            background: 'transparent',
            border: 0,
            color: corC.muted,
            fontFamily: fonteC.corpo,
            fontSize: 13.5,
            textDecoration: 'underline',
            textUnderlineOffset: 3,
            cursor: 'pointer',
          }}
        >
          enviar um arquivo de áudio
        </button>
      </div>
    </div>
  );
}
